let defaultButtons = [
  {
    classes: ['btn', 'btn-default'],
    type: 'default',
    style: {color: '#000'},
    background: {
      color: '#CCC'
    }
  },
  {
    classes: ['btn', 'btn-primary'],
    type: 'primary',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-success'],
    type: 'success',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-info'],
    type: 'info',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-warning'],
    type: 'warning',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-danger'],
    type: 'danger',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  }
];

export default defaultButtons;
